import { render, staticRenderFns } from "./FormCity.vue?vue&type=template&id=235c1eff&"
import script from "./FormCity.vue?vue&type=script&lang=js&"
export * from "./FormCity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VAutocomplete,VExpandTransition})
